import { CardLogos } from "@/components/CardLogos/CardLogos.tsx";
import Container from "@/components/Container/Container.tsx";
import { SwenLogo } from "@/components/Icons/SwenLogo.tsx";
import { useLegalModalStore } from "@/components/LegalModal/store/useLegalModalStore.ts";
import { hideTermsAndPrivacyPolicy } from "@/helpers/customFeatures.ts";
import { useGetOrganization } from "@/helpers/useGetOrganization.ts";
import { getAPIUrl } from "@/stores/ApolloClient/helpers/getAPIUrl.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";
import i18n from "i18next";
import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  const rootAttributes = useEngineStore((state) => state.rootAttributes);
  const { privacyPolicy, termsAndConditions, organizationName } = useGetOrganization();
  const handleOpenModal = useLegalModalStore((state) => state.handleOpenModal);

  const handleTermsClick = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
    handleOpenModal(termsAndConditions);
  };

  const handlePrivacyPolicyClick = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (getAPIUrl().includes("materra")) {
      switch (i18n.language) {
        case "en":
          window.location.href = "https://hotelmaterra.com/en/privacy-policy/";
          break;
        case "hr":
          window.location.href = "https://hotelmaterra.com/politika-privatnosti/";
          break;
      }
      return;
    }

    handleOpenModal(privacyPolicy);
  };

  return (
    <div className="o-booking-engine__footer">
      <Container>
        <div className="c-be-footer">
          <p className="u-p1 c-be-footer__credits">
            {
              // TODO: custom stuff, remove in future
              getAPIUrl().includes("simuni") ? null : (
                <>
                  <span className="c-be-footer__text">{t("poweredBy")}: </span>
                  <a
                    className="c-be-footer__logo"
                    href="https://www.hiswen.com/"
                    target="_blank"
                    rel="noreferrer"
                    title="SWEN"
                  >
                    <SwenLogo />
                  </a>
                </>
              )
            }
          </p>
          {hideTermsAndPrivacyPolicy.includes(organizationName || "") || (
            <div className="c-be-footer__right">
              <ul className="c-be-footer__links">
                <li>
                  <button className="c-be-underline-link" onClick={handleTermsClick}>
                    <span className="c-be-underline-link__label u-p1">
                      {t("termsAndConditions.footerLink")}
                    </span>
                  </button>
                </li>
                <li>
                  <button className="c-be-underline-link" onClick={handlePrivacyPolicyClick}>
                    <span className="c-be-underline-link__label u-p1">{t("privacyPolicy.footerLink")}</span>
                  </button>
                </li>
              </ul>
              {!!rootAttributes?.[RootAttribute.ShowCardLogos]?.length && (
                <CardLogos cards={rootAttributes[RootAttribute.ShowCardLogos]} />
              )}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};
